import { PaymentState } from './state';
import { productsInitialState } from './initial-state';
import { PaymentActions } from './action-creators';
import * as actions from './actions';

export const paymentReducer = (
  state: PaymentState = productsInitialState,
  action: PaymentActions
): PaymentState => {
  switch (action.type) {
    case actions.GET_PAYMENT_METHODS_SUCCESS: {
      return {
        ...state,
        methods: {
          ...state.methods,
          [action.ownerId]: action.list,
        },
      };
    }

    default:
      return state;
  }
};
